import { Tooltip as AntTooltip } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'

import { mouseEnterDelay, mouseLeaveDelay } from '../constants'

const Tooltip = (props: TooltipProps) => {
    const { children, ...toolTipProps } = props

    return (
        <AntTooltip
            {...toolTipProps}
            mouseEnterDelay={mouseEnterDelay}
            mouseLeaveDelay={mouseLeaveDelay}
        >
            {children}
        </AntTooltip>
    )
}

export default Tooltip
